export default {
    nonBfiDetailModal: {
        isOpen: false,
    },
    bfiDetailModal: {
        isOpen: false,
    },
    auditHistoryModal: {
        isOpen: false,
    },
};
